import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import GuidaCompleta from "@/pages/article/itaobuy-spreadsheet-guida-completa/page";
import Sicurezza from "@/pages/article/itaobuy-spreadsheet-sicurezza/page";
import VsAlternative from "@/pages/article/itaobuy-spreadsheet-vs-alternative/page";
import Migliore from "@/pages/article/migliore-itaobuy-spreadsheet/page";
import Principianti from "@/pages/article/itaobuy-spreadsheet-per-principianti/page";
import Strategie from "@/pages/article/itaobuy-spreadsheet-strategie-avanzate/page";
import Recensioni from "@/pages/article/itaobuy-spreadsheet-recensioni/page";
import Categorie from "@/pages/article/itaobuy-spreadsheet-categorie/page";
import ComeUsare from "@/pages/article/come-usare-itaobuy-spreadsheet/page";
// Brand cluster
import Nike from "@/pages/article/itaobuy-spreadsheet-nike/page";
import Adidas from "@/pages/article/itaobuy-spreadsheet-adidas/page";
import Jordan from "@/pages/article/itaobuy-spreadsheet-jordan/page";
import NewBalance from "@/pages/article/itaobuy-spreadsheet-new-balance/page";
import Puma from "@/pages/article/itaobuy-spreadsheet-puma/page";
// Esigenze cluster
import Economico from "@/pages/article/itaobuy-spreadsheet-economico/page";
import Qualita from "@/pages/article/itaobuy-spreadsheet-qualita-migliore/page";
import Affidabile from "@/pages/article/itaobuy-spreadsheet-affidabile/page";
import Spedizione from "@/pages/article/itaobuy-spreadsheet-spedizione-veloce/page";
import EdizioneLimitata from "@/pages/article/itaobuy-spreadsheet-edizione-limitata/page";
// Domande cluster
import Legale from "@/pages/article/itaobuy-spreadsheet-e-legale/page";
import Conviene from "@/pages/article/itaobuy-spreadsheet-conviene/page";
import DoveTrovare from "@/pages/article/dove-trovare-itaobuy-spreadsheet/page";
import Truffa from "@/pages/article/itaobuy-spreadsheet-truffa-o-no/page";
import ValeLaPena from "@/pages/article/itaobuy-spreadsheet-vale-la-pena/page";
// Categorie cluster
import Sneakers from "@/pages/article/itaobuy-spreadsheet-sneakers/page";
import Hoodie from "@/pages/article/itaobuy-spreadsheet-hoodie/page";
import Orologi from "@/pages/article/itaobuy-spreadsheet-orologi/page";
import Borse from "@/pages/article/itaobuy-spreadsheet-borse/page";
import Accessori from "@/pages/article/itaobuy-spreadsheet-accessori-moda/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  // Existing pillar articles (9)
  { path: "/articoli/itaobuy-spreadsheet-guida-completa", element: <GuidaCompleta /> },
  { path: "/articoli/itaobuy-spreadsheet-sicurezza", element: <Sicurezza /> },
  { path: "/articoli/itaobuy-spreadsheet-vs-alternative", element: <VsAlternative /> },
  { path: "/articoli/migliore-itaobuy-spreadsheet", element: <Migliore /> },
  { path: "/articoli/itaobuy-spreadsheet-per-principianti", element: <Principianti /> },
  { path: "/articoli/itaobuy-spreadsheet-strategie-avanzate", element: <Strategie /> },
  { path: "/articoli/itaobuy-spreadsheet-recensioni", element: <Recensioni /> },
  { path: "/articoli/itaobuy-spreadsheet-categorie", element: <Categorie /> },
  { path: "/articoli/come-usare-itaobuy-spreadsheet", element: <ComeUsare /> },
  // Brand cluster (5)
  { path: "/articoli/itaobuy-spreadsheet-nike", element: <Nike /> },
  { path: "/articoli/itaobuy-spreadsheet-adidas", element: <Adidas /> },
  { path: "/articoli/itaobuy-spreadsheet-jordan", element: <Jordan /> },
  { path: "/articoli/itaobuy-spreadsheet-new-balance", element: <NewBalance /> },
  { path: "/articoli/itaobuy-spreadsheet-puma", element: <Puma /> },
  // Esigenze cluster (5)
  { path: "/articoli/itaobuy-spreadsheet-economico", element: <Economico /> },
  { path: "/articoli/itaobuy-spreadsheet-qualita-migliore", element: <Qualita /> },
  { path: "/articoli/itaobuy-spreadsheet-affidabile", element: <Affidabile /> },
  { path: "/articoli/itaobuy-spreadsheet-spedizione-veloce", element: <Spedizione /> },
  { path: "/articoli/itaobuy-spreadsheet-edizione-limitata", element: <EdizioneLimitata /> },
  // Domande cluster (5)
  { path: "/articoli/itaobuy-spreadsheet-e-legale", element: <Legale /> },
  { path: "/articoli/itaobuy-spreadsheet-conviene", element: <Conviene /> },
  { path: "/articoli/dove-trovare-itaobuy-spreadsheet", element: <DoveTrovare /> },
  { path: "/articoli/itaobuy-spreadsheet-truffa-o-no", element: <Truffa /> },
  { path: "/articoli/itaobuy-spreadsheet-vale-la-pena", element: <ValeLaPena /> },
  // Categorie cluster (5)
  { path: "/articoli/itaobuy-spreadsheet-sneakers", element: <Sneakers /> },
  { path: "/articoli/itaobuy-spreadsheet-hoodie", element: <Hoodie /> },
  { path: "/articoli/itaobuy-spreadsheet-orologi", element: <Orologi /> },
  { path: "/articoli/itaobuy-spreadsheet-borse", element: <Borse /> },
  { path: "/articoli/itaobuy-spreadsheet-accessori-moda", element: <Accessori /> },
  // Not found
  { path: "*", element: <NotFound /> },
];

export default routes;